
import JobCard from "@/components/job/card/JobCard"
import Score from "@/components/base/Score"

import jobService from "@/services/job.service"
import datesMixin from "@/mixins/dates"
import { STATUS_APPROVED, STATUS_REJECTED } from "@/services/v2/review.service"

export default {
    name: "JobReviewed",
    components: {
        JobCard,
        Score,
        HelpTooltip: () => import("@/components/base/design/HelpTooltip"),
    },
    mixins: [datesMixin],
    props: {
        message: {
            type: Object,
            required: true,
        },
        isSelf: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        job: null,
        body: {},
        error: null,
        isLoading: true,
    }),
    computed: {
        jobType() {
            if (!this.job) return "Dein Beruf"
            if (this.job.type?.id === 1 || this.job.type_id === 1)
                return "Deine Ausbildung"
            if (this.job.type?.id === 2 || this.job.type_id === 2)
                return "Dein Praktikum"
            return "Dein Beruf"
        },
        review() {
            return this.body?.params?.review || {}
        },
        isAccepted() {
            return this.review.status === STATUS_APPROVED
        },
        isRejected() {
            return this.review.status === STATUS_REJECTED
        },
    },
    async mounted() {
        this.body = JSON.parse(this.message.body)
        const params = this.body.params
        this.job = params.review.job
        jobService
            .getJobBySlug(params.review.job.slug)
            .then((job) => (this.job = job))
            .catch((err) => (this.error = err))
            .finally(() => (this.isLoading = false))
    },
}
